import React, { useState, useEffect } from 'react';
import './PatientInfoModal.css';
import * as Yup from 'yup';
import { ImCancelCircle } from 'react-icons/im';

import BeatLoader from "react-spinners/BeatLoader";
import { doc, collection,query, where, getDocs  } from "firebase/firestore";
import { db } from '../../../firebase/firebase-config';

const override = {
    marginTop: "20px",
  };

function PatientInfoModal({ onCancel, user, color="#4F5052", } : any) {
    const [loading, setLoading] = useState(false);
    const [numCases, setNumCases] = useState(null);
    const [allCases, setAllCases] = useState([]);

    const fetchOtherCases = async () => {
        const casesDocRef =  query(collection(db, "Cases"), where("patient_uid", "==", user?.id));
        const docs = await getDocs(casesDocRef);

        let data: any =  [];

        docs.forEach((val: any) => {
            data.push({
                ...val.data(),
                id: val.id
            });
        })

        setNumCases(data.length);
        setAllCases(data);
        // console.log('DATA: ', data);
    }

    useEffect(() => {
        fetchOtherCases();
    },[])

    return (
        <div>
            <div  className='add-patient-modal-container modal-details'>
                <div className='modal-head' style={{backgroundColor: color}}>
                   
                    <p className="modal-title">Patient's Detail</p>
                    <ImCancelCircle style={{cursor: 'pointer'}} onClick={onCancel} size={22} color="#fff"/>
                </div>
                <div style={{display: 'flex',  justifyContent: 'center', alignItems: 'center'}}>
                    <BeatLoader
                        color="#3080ED"
                        loading={loading}
                        cssOverride={override}
                    />
                    </div>
                <div className='details modal-content'>
                    <div className="modal-content-row">
                        <div className="info-element">
                            <div className="info-left">
                                <p className="title">Name:</p>
                            </div>
                            <div className="info-right">
                                <p className="value-text">{user?.displayName}</p>
                            </div>
                            
                       </div>
                       
                       <div className="info-element">
                            <div className="info-left">
                                <p className="title">Email:</p>
                            </div>
                            <div className="info-right">
                                <p className="value-text">{user?.email}</p>
                            </div>
                            
                       </div>

                       <div className="info-element">
                            <div className="info-left">
                                <p className="title">Gender:</p>
                            </div>
                            <div className="info-right">
                                <p className="value-text">{user?.gender}</p>
                            </div>
                            
                       </div>
                       
                       <div className="info-element">
                            <div className="info-left">
                                <p className="title">Phone:</p>
                            </div>
                            <div className="info-right">
                                <p className="value-text">{user?.phoneNumber}</p>
                            </div>
                            
                       </div>

                         
                       <div className="info-element">
                            <div className="info-left">
                                <p className="title">Verified:</p>
                            </div>
                            <div className="info-right">
                                <p className="value-text">{user?.is_verified ? 'Yes' : 'No'}</p>
                            </div>
                            
                       </div>

                       <div className="info-element">
                            <div className="info-left">
                                <p className="title">Number Of Active Cases:</p>
                            </div>
                            <div className="info-right">
                                <p className="value-text">{user?.active_cases?.length ?? 0}</p>
                            </div>
                            
                       </div>

                       <div className="info-element">
                            <div className="info-left">
                                <p className="title">Number Of Cases:</p>
                            </div>
                            <div className="info-right">
                                <p className="value-text">{numCases}  - {allCases.map((data: any) => `${data?.CID}, `)}</p>
                            </div>
                            
                       </div>

                    </div>
                </div>
            </div>
            <div className="modal-shadow" onClick={onCancel}>
           
            </div>
        </div>
    );
}

export default PatientInfoModal;